import Component from '@bythepixel/component-loader';

/**
 * Records a landing-page conversion when a link-type CTA button is clicked.
 * Form-type CTAs (`comp-landing-contact-open`) convert on submission instead, so
 * only navigating anchors carry `data-lp-conversion`. `keepalive` lets the POST
 * finish even as the click navigates the page away. Raw count — no dedup.
 */
export default class LandingConversion extends Component {
  static selector = '[data-lp-conversion]'

  constructor(...args) {
    super(...args);
    this.pageId = this.$container.getAttribute('data-lp-conversion');
    this.$container.addEventListener('click', () => this.record());
  }

  record() {
    if (!this.pageId) return;

    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

    fetch(`/lp/${this.pageId}/conversion`, {
      method: 'POST',
      headers: { 'X-CSRF-TOKEN': token || '' },
      keepalive: true,
    }).catch(() => {});
  }
}
